import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PipesModule } from '../../../core/pipes/pipes.module';
import { TooltipsModule } from '../../features/tooltip/tooltips.module';
import { IconModule } from '../icon/icon-module';
import { RadioModule } from '../input/radio/radio.module';
import { FormulaBuilderCustomFieldsComponent } from './formula-builder-custom-fields/formula-builder-custom-fields.component';
import { FormulaBuilderFieldComponent } from './formula-builder-field/formula-builder-field.component';
import { FormulaBuilderOperatorsComponent } from './formula-builder-operators/formula-builder-operators.component';
import { FormulaBuilderComponent } from './formula-builder.component';
import { FormulaInputComponent } from './formula-input/formula-input.component';
import { FormulaPieceComponent } from './formula-piece/formula-piece.component';

@NgModule({
  declarations: [
    FormulaBuilderComponent,
    FormulaBuilderFieldComponent,
    FormulaBuilderOperatorsComponent,
    FormulaInputComponent,
    FormulaPieceComponent,
    FormulaBuilderCustomFieldsComponent,
  ],
  imports: [
    CommonModule,
    PipesModule,
    FormsModule,
    TooltipsModule,
    IconModule,
    RadioModule,
    CdkDropList,
    CdkDrag,
    BrowserAnimationsModule,
  ],
  exports: [FormulaBuilderComponent],
})
export class FormulaBuilderModule {}
